
import React from 'react';
import EnhancedLoadingState from '@/components/dashboard/EnhancedLoadingState';

interface DashboardLoadingStateProps {
  loading: boolean;
  dataLoadError: string | null;
  children: React.ReactNode;
}

const DashboardLoadingState: React.FC<DashboardLoadingStateProps> = ({
  loading,
  dataLoadError,
  children
}) => {
  return (
    <EnhancedLoadingState
      loading={loading}
      dataLoadError={dataLoadError}
      stage="data"
    >
      {children}
    </EnhancedLoadingState>
  );
};

export default DashboardLoadingState;
